<template>
  <a v-if="button.type === 'url'" :href="button.url" @click.prevent="onUrlButtonClick">
    <button
      type="button"
      :class="classes"
    >
      {{ button.title }}
    </button>
  </a>

  <button
    v-else-if="isNonUrlButtonType"
    type="button"
    :class="classes"
    @click="submitButton()"
  >
    <div class="quick-reply-button__container">
      <div class="quick-reply-button__container__text">{{ button.title }}</div>
      <div v-if="button.isDisabled" class="quick-reply-button__container__icon">
        <info-icon />
      </div>
    </div>
  </button>
</template>

<script>
// @flow

import { mapActions, mapState } from 'vuex'

import { logger } from '../../../common'
import { createClick } from '../../../common/api/chatchampApi'
import { MESSAGE_TYPE_URL_BUTTON } from '../../../common/iframeMessageTypes'
import { CHATBOT_EVENTS, dispatchChatchampEvent } from '../../../main/eventTracking'

import { buttonClickMixin, postMessageMixin } from '../../mixins'

import InfoIcon from '../Icons/InfoIcon.vue'

import { ButtonTypes } from './ButtonTypes'

export default {
  components: {
    InfoIcon
  },
  mixins: [buttonClickMixin, postMessageMixin],
  props: {
    button: {
      type: Object,
      default: () => {
      }
    },
    message: {
      type: Object,
      default: () => {
      }
    },
    emphasize: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      sending: false
    }
  },
  computed: {
    ...mapState(['customerId', 'subscriberId']),
    classes (): Object {
      return {
        'quick-reply-button': true,
        'quick-reply-button--is-highlighted': this.button.isHighlighted,
        'quick-reply-button--emphasize': this.emphasize,
        'quick-reply-button--is-disabled': this.button.isDisabled,
        [this.button.type]: this.button.type !== 'url'
      }
    },
    isNonUrlButtonType (): boolean {
      const nonUrlButtonTypes = { ...ButtonTypes }
      delete nonUrlButtonTypes.URL

      return Object.values(nonUrlButtonTypes).includes(this.button.type)
    }
  },
  methods: {
    ...mapActions(['toggleNotification']),
    async submitButton () {
      if (this.button.isDisabled) {
        this.toggleNotification('leadsToNoRecommendation')
        return
      }

      await this.clickButton(this.button, this.message)
      if (this.button.attribute) this.notifyUserAttributeSet(this.button.attribute)
    },
    submitUrl () {
      this.postMessage({
        event: MESSAGE_TYPE_URL_BUTTON,
        url: this.button.url,
        chatbotId: this.message.chatbotId
      })
      dispatchChatchampEvent(CHATBOT_EVENTS.UrlButtonClicked, {
        url: this.button.url,
        chatbotId: this.message.chatbotId
      })
    },
    async onUrlButtonClick () {
      if (this.sending) return

      try {
        this.sending = true
        logger.info(`Subscriber clicked button ${this.button.payload}...`)

        this.submitUrl()
        await createClick(this.customerId, this.subscriberId, this.button.payload)

        if (this.button.target === '_blank') {
          // Thiago; 16.06.2023; it is a workaround to avoid blocking new window on Safari
          setTimeout(() => window.open(this.button.url))
        } else {
          window.parent.location.href = this.button.url
        }
      } catch (error) {
        logger.error(error)
      } finally {
        this.sending = false
      }
    }
  }
}
</script>

<style src="./chatchamp-button.scss" />
